import { render } from "./FeedView.vue?vue&type=template&id=406d1051"
import script from "./FeedView.vue?vue&type=script&lang=js"
export * from "./FeedView.vue?vue&type=script&lang=js"
script.render = render

export default script